/**
 * Redirect to the OIDC provider end_session endpoint (Keycloak logout).
 */

export async function hardRedirectToEndSession(params: {
  authority?: string
  clientId?: string
  idTokenHint?: string
  postLogoutRedirectUri: string
}): Promise<void> {
  const { authority, clientId, idTokenHint, postLogoutRedirectUri } = params
  if (typeof window === 'undefined') return
  if (!authority) {
    window.location.href = '/'
    return
  }

  try {
    const base = authority.replace(/\/$/, '')
    const wellKnown = `${base}/.well-known/openid-configuration`
    const res = await fetch(wellKnown, { method: 'GET' })
    const json = res.ok ? await res.json() : {}
    let endSession: string | undefined = json.end_session_endpoint

    if (!endSession) {
      endSession = `${base}/protocol/openid-connect/logout`
    }

    const url = new URL(endSession)
    if (idTokenHint) url.searchParams.set('id_token_hint', idTokenHint)
    if (clientId) url.searchParams.set('client_id', clientId)
    url.searchParams.set('post_logout_redirect_uri', postLogoutRedirectUri)
    window.location.href = url.toString()
  } catch {
    const base = authority.replace(/\/$/, '')
    const url = new URL(`${base}/protocol/openid-connect/logout`)
    if (idTokenHint) url.searchParams.set('id_token_hint', idTokenHint)
    if (clientId) url.searchParams.set('client_id', clientId)
    url.searchParams.set('post_logout_redirect_uri', postLogoutRedirectUri)
    window.location.href = url.toString()
  }
}
